import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, TextField} from 'views/components';
import {Translate} from 'views/module';

const CareScheduleBox = (props) => {
  const {data, updateFormData} = props;

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.CareScheduleBox.Title" />
        </Typography>
      </Box>

      {/* Schedule Title */}
      <Typography variant="subtitle2" style={{marginTop: 0}}>
        <Translate expression="profile.CareScheduleBox.Schedule" />
      </Typography>
      <Box sx={{padding: '0.5rem 0'}}>
        <TextField
          value={data.schedule}
          onChange={(e) => updateFormData('schedule', e)}
          multiline
          minRows={1}
          fullWidth
          size="small"
          inputProps={{style: {fontSize: 14}}}
        />
      </Box>
    </Box>
  );
};

CareScheduleBox.propTypes = {
  data: PropTypes.shape({
    schedule: PropTypes.string,
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default CareScheduleBox;
